




















import { Vue, Component } from "vue-property-decorator";
import ProjectsTable from "../component/project/ProjectsTable.vue";

@Component({
	components: {
		ProjectsTable,
	}
})
export default class ProjectsView extends Vue {
}
